import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=3e8fede5&scoped=true&"
import script from "./CommentList.vue?vue&type=script&lang=js&"
export * from "./CommentList.vue?vue&type=script&lang=js&"
import style0 from "./CommentList.vue?vue&type=style&index=0&id=3e8fede5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8fede5",
  null
  
)

component.options.__file = "CommentList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VChip,
  VContainer,
  VDataTable,
  VDatePicker,
  VDialog,
  VFlex,
  VLayout,
  VSelect,
  VSpacer,
  VTextField,
})
